import React from 'react';

export const DefaultHeader = () => {
  return (
    <h3 className="vads-u-margin-bottom--3">
      Confirm the personal information we have on file for you.
    </h3>
  );
};
